<div class="help-dialog">
  <div>
    <h3>{{ title }}</h3>
    <span>{{ body }}</span>
    <button (click)="close()" class="pg-button">Close</button>
  </div>
</div>
